"use strict";

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _numeral = _interopRequireDefault(require("numeral"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// CURRENCY FORMATTING
var CurrencyUtils = /*#__PURE__*/function () {
  function CurrencyUtils() {
    _classCallCheck(this, CurrencyUtils);
  }

  _createClass(CurrencyUtils, null, [{
    key: "currencyToFloat",

    /**
     * @param {value} input type is a string e.g. '1000000'
     * @returns {string} applies the formatting to the value provided.
     * Can further customize the format  as a parameter.
     * As a failsafe, returns '-';
     * http://numeraljs.com/
     */

    /**
     * This will return a float from a value input
     *
     * @returns {float} value
     */
    value: function currencyToFloat(value) {
      if (typeof value !== 'number' && value !== null) {
        value = parseFloat(value.replace(/[$,]/g, ''));

        if (typeof value !== 'number') {
          throw new TypeError();
        }
      }

      return value;
    }
  }]);

  return CurrencyUtils;
}();

exports.default = CurrencyUtils;

_defineProperty(CurrencyUtils, "formatCurrency", function (value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$0,0.00';

  if (isNaN(parseFloat(value))) {
    return value;
  }

  return (0, _numeral.default)(value).format(format);
});
//# sourceMappingURL=CurrencyUtils.js.map